export interface Tray {
    letters: (Letter | null)[];
}

export interface ScoreResult {
    words: WordResult[];
    total: number;
}

export interface WordResult {
    word: string;
    score: number;
}

export interface PlayedTile {
    index: number;
    character?: string;
}

export interface Difficulty {
    proportion: number;
    randomness: number;
}

export interface Letter {
    readonly text: string;
    readonly points: number;
    readonly ephemeral: boolean;
    readonly is_blank: boolean;
}

export type TurnAction =
    | { type: "Pass" }
    | { type: "ExchangeTiles"; tiles_exchanged: number }
    | { type: "PlayTiles"; result: ScoreResult; locations: number[] }
    | { type: "AddToDictionary"; word: string };

export enum CellType {
    Normal = "Normal",
    DoubleWord = "DoubleWord",
    DoubleLetter = "DoubleLetter",
    TripleLetter = "TripleLetter",
    TripleWord = "TripleWord",
    Start = "Start",
}

export type GameState =
    | { type: "InProgress" }
    | {
          type: "Ended";
          finisher?: string;
          remaining_tiles: { [id: string]: Letter[] };
      };

export interface APIPlayer {
    name: string;
    tray_tiles: number;
    score: number;
}

export interface PublicInformation {
    game_state: GameState;
    board: Array<Letter>;
    cell_types: Array<CellType>;
    current_player: string;
    players: Array<APIPlayer>;
    remaining_tiles: number;
    history: Array<Update>;
    current_turn_number: number;
}

export interface Update {
    type: TurnAction;
    player: string;
    turn_number: number;
}

export interface APIState {
    public_information: PublicInformation;
    tray: Tray;
    update?: Update;
}

export interface Result<A, B> {
    Ok?: A;
    Err?: B;
}

export function is_ok<A, B>(result: Result<A, B>): boolean {
    return result["Ok"] != null;
}

export interface API {
    exchange: (selection: Array<boolean>) => Promise<APIState>;
    pass: () => Promise<APIState>;
    play: (tiles: Array<PlayedTile>, commit: boolean) => Promise<APIState>;
    add_to_dictionary: (word: string) => Promise<APIState>;
    load: (wait: boolean) => Promise<APIState>;
}
